import { apiAgent } from './apiService';

export const agentService = {
  async getAgents(organizationId = null) {
    try {
      let url = '/admin/agents';
      if (organizationId) url += `?organization_id=${organizationId}`;
      const response = await apiAgent.get(url);
      return response.data;
    } catch (error) {
      if (error.response?.status === 401) throw new Error('Session expirée. Veuillez vous reconnecter.');
      if (error.response?.status === 404) throw new Error('Aucun agent trouvé.');
      throw new Error('Erreur lors de la récupération des agents.');
    }
  },

  async getAgent(agentId) {
    try {
      const response = await apiAgent.get(`/admin/agents/${agentId}`);
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) throw new Error('Agent non trouvé.');
      if (error.response?.status === 403) throw new Error('Accès non autorisé à cet agent.');
      throw new Error("Erreur lors de la récupération de l'agent.");
    }
  },

  async createAgent(agentData) {
    try {
      const response = await apiAgent.post('/admin/agents', agentData);
      return response.data;
    } catch (error) {
      if (error.response?.status === 400) throw new Error(error.response.data?.detail || "Données d'agent invalides.");
      throw new Error("Erreur lors de la création de l'agent.");
    }
  },

  async updateAgent(agentId, agentData) {
    try {
      const response = await apiAgent.put(`/admin/agents/${agentId}`, agentData);
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) throw new Error('Agent non trouvé.');
      if (error.response?.status === 403) throw new Error('Accès non autorisé à cet agent.');
      if (error.response?.status === 400) throw new Error(error.response.data?.detail || "Données d'agent invalides.");
      throw new Error("Erreur lors de la mise à jour de l'agent.");
    }
  },

  async deleteAgent(agentId) {
    try {
      const response = await apiAgent.delete(`/admin/agents/${agentId}`);
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) throw new Error('Agent non trouvé.');
      if (error.response?.status === 403) throw new Error('Accès non autorisé à cet agent.');
      throw new Error("Erreur lors de la suppression de l'agent.");
    }
  },
};

export default agentService;

